export const NEWSBOARD_POST_PROFILE_TIME_RANGE_START_FIELD_NAME = 'date_from'

export const NEWSBOARD_POST_PROFILE_TIME_RANGE_END_FIELD_NAME = 'date_to'

export const NEWSBOARD_POST_PROFILE_EDIT_TIME_RANGE_MODAL_QA_NAME =
  'newsboardPostProfileEditTimeRange'

export const NEWSBOARD_POST_PROFILE_EDIT_TIME_RANGE_MODAL_SUBMIT_QA_NAME =
  'Save'
